module.exports = __webpack_public_path__ + "img/pjt-logo-2.78913019.png";